$('.js-search').click(function () {
	const searchItem = $(this).parents('.search');
	searchItem.find('.search__block').fadeIn(300);
	searchItem.find('.form-control_search').focus();
	//$('.page').addClass('page_search');
});

$(document).click(function (e) {
	if (!$(e.target).closest('.search').length) {
		$('.search__block').fadeOut(300);
		//$('.page').removeClass('page_search');
	}
	e.stopPropagation();
});



// WEBPACK FOOTER //
// ./_dev/blocks/search/search.js